import { render, staticRenderFns } from "./LayoutSoftphone.vue?vue&type=template&id=8e092548&scoped=true"
import script from "./LayoutSoftphone.vue?vue&type=script&lang=js"
export * from "./LayoutSoftphone.vue?vue&type=script&lang=js"
import style0 from "./LayoutSoftphone.vue?vue&type=style&index=0&id=8e092548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e092548",
  null
  
)

export default component.exports